module.exports = __webpack_public_path__ + "static/media/024.045d8e95.jpg";